import { isMobileDevice } from "@/utils/matchMedia";
import { TestPageList } from "@/views/inspectionLite/components/OtherPages/utils/index.js";
// 简化建模检测新store存储模块
export default {
  namespaced: true,
  state: {
    TestPage: null, // 检测/调查页面数据
    rightMenuActive: {}, // 右键菜单
    comMenuActive: {}, // 组件菜单
    comShow: false, // 检测窗口弹出显隐
    partShow: false, // 构件操作弹出显隐
    AxisShow: false, // 选择轴线弹出录入表显隐
    rotateShow: false, // 旋转弹窗显隐
    bottomShow: false, // 底部操作弹出显隐
    axisNamingShow: false, // 轴线命名弹窗显隐
    generateShow: false, // 生成表格显隐
    crossGridShow: false, // 正交轴网弹窗显隐
    sketchChangeErrorShow: false, // 草图线错误检查弹窗显隐
    setSketchShow: false, // 设置草图弹窗显隐
    setModelNoShow: false, // 设置构件号弹窗显隐
    sketchChangeErrorData: {}, // 草图线错误检查数据
    arcGridShow: false, // 弧形轴网弹窗显隐
    upperNodeHeightShow: false, // 上节点高弹窗显隐
    currentItem: {}, // 当前构件
    backgroundImageId: null, // 背景图片id
    backgroundImageIdShow: false, // 背景图片id显隐
    isRoundSketch: true, //草图转正是否按50模式取整
    isAddWallThicknessSketch: true, //草图转正是否增加厚度
    wallThicknessValueSketch: 200, //草图转正增加的厚度
    // 当前绘制轴线的方式
    currentAxisType: "DrawLine",
    currentSketchType: "DrawSketch",
    isInCommand: false, // 是否在命令中
    buttonVisibility: {}, // 存储底部菜单按钮的显隐状态
    endButtonShow: false, // 结束按钮显示状态
    operationType: null, // 当前操作类型
    endButtonText: "", // 结束按钮文本
    checkStatus: {}, // 检查状态
    findIds: [],
    rotateAngleShow: false, // 旋转角度显隐
    doorWindowIsChange: false, // 门洞是否靠近另一个方向
    isFristDraw: false, //判断是否是第一次
  },
  mutations: {
    // 设置当前检测盒子页面数据
    setTestPage(state, obj) {
      state.TestPage = obj;
    },
    // 设置右键菜单选中
    setRightMenuActive(state, obj) {
      state.rightMenuActive = obj;
    },
    // 设置组件菜单选中
    setcomMenuActive(state, obj) {
      state.comMenuActive = obj;
    },
    // 设置组件菜单选中后的弹窗显隐
    setcomShow(state, obj) {
      state.comShow = obj;
    },
    // 设置构件操作弹出显隐
    setpartShow(state, obj) {
      state.partShow = obj;
    },
    // 设置轴线弹出显隐
    setAxisShow(state, obj) {
      state.AxisShow = obj;
    },
    setAxisNamingShow(state, obj) {
      state.axisNamingShow = obj;
    },
    // 设置旋转构件弹窗显隐
    setRotateShow(state, obj) {
      state.rotateShow = obj;
    },
    // 底部操作弹出显隐
    setbottomShow(state, obj) {
      state.bottomShow = obj;
    },
    // 生成表格显隐
    setgenerateShow(state, obj) {
      state.generateShow = obj;
    },
    // 设置正交轴网弹窗显隐
    setcrossGridShow(state, obj) {
      state.crossGridShow = obj;
    },
    // 设置弧形轴网弹窗显隐
    setarcGridShow(state, obj) {
      state.arcGridShow = obj;
    },
    // 设置上节点高弹窗显隐
    setupperNodeHeightShow(state, obj) {
      state.upperNodeHeightShow = obj;
    },
    // 设置草图线错误检查弹窗显隐
    setsketchChangeErrorShow(state, obj) {
      state.sketchChangeErrorShow = obj;
    },
    // 设置设置草图弹窗显隐
    setsetSketchShow(state, obj) {
      state.setSketchShow = obj;
    },
    // 设置设置构件号弹窗显隐
    setsetModelNoShow(state, obj) {
      state.setModelNoShow = obj;
    },
    // 设置草图线错误检查数据
    setsketchChangeErrorData(state, obj) {
      state.sketchChangeErrorData = obj;
    },
    // 生成表格显隐
    setcurrentItem(state, obj) {
      state.currentItem = obj || {};
    },
    // 设置背景图片id
    setbackgroundImageId(state, obj) {
      state.backgroundImageId = obj;
    }, // 设置背景图片id显隐
    setbackgroundImageIdShow(state, obj) {
      state.backgroundImageIdShow = obj;
    },
    // 设置背景图片id显隐
    setbackgroundImageIdShow(state, obj) {
      state.backgroundImageIdShow = obj;
    },
    // 设置草图转正是否按50模式取整
    setIsRoundSketch(state, obj) {
      state.isRoundSketch = obj;
    },
    // 设置草图转正是否增加厚度
    setIsAddWallThicknessSketch(state, obj) {
      state.isAddWallThicknessSketch = obj;
    },
    // 设置草图转正增加的厚度
    setWallThicknessValueSketch(state, obj) {
      state.wallThicknessValueSketch = obj;
    },
    // 设置当前绘制轴线的方式
    setCurrentAxisType(state, obj) {
      state.currentAxisType = obj;
    },
    setCurrentSketchType(state, obj) {
      state.currentSketchType = obj;
    },
    setIsInCommand(state, obj) {
      state.isInCommand = obj;
    },
    // 设置底部菜单按钮的显隐状态
    setButtonVisibility(state, { type, isVisible }) {
      state.buttonVisibility = {
        ...state.buttonVisibility,
        [type]: isVisible,
      };
    },
    // 设置结束按钮显示状态
    SET_END_BUTTON_SHOW(state, show) {
      state.endButtonShow = show;
      // if (show && isMobileDevice()) {
      //   // 如果是移动端才判断是否是第一次画，否则不算
      //   state.isFristDraw = true;
      // } else {
      //   state.isFristDraw = false;
      // }
    },
    // 设置当前操作类型
    SET_OPERATION_TYPE(state, type) {
      state.operationType = type;
    },
    // 设置结束按钮文本
    SET_END_BUTTON_TEXT(state, text) {
      state.endButtonText = text;
    },
    // 设置检查状态
    setCheckStatus(state, obj) {
      state.checkStatus = obj;
    },
    setFindId(state, findId) {
      if (findId) {
        state.findIds.push(findId);
      } else {
        state.findIds = [state.findIds[state.findIds.length - 1]];
      }
      //只要最后三个，不要缓存太多
      if (state.findIds.length > 3) {
        state.findIds = state.findIds.slice(-3);
      }
    },
    setRotateAngleShow(state, obj) {
      console.log("obj", obj);

      state.rotateAngleShow = obj;
    },
    setDoorWindowIsChange(state, obj) {
      state.doorWindowIsChange = obj;
    },
  },
  actions: {
    // 获取当前自然层列表
    generatePages({ commit }, key) {
      return new Promise((resolve) => {
        const accessedPage = TestPageList.find((item) => item.pageKey === key);
        commit("setTestPage", accessedPage || null);
        resolve(accessedPage);
      });
    },
  },
  getters: {},
};
